import { render, staticRenderFns } from "./PlanSwitchHistoryModal.vue?vue&type=template&id=33721488&scoped=true&"
import script from "./PlanSwitchHistoryModal.vue?vue&type=script&lang=js&"
export * from "./PlanSwitchHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./PlanSwitchHistoryModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PlanSwitchHistoryModal.vue?vue&type=style&index=1&id=33721488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33721488",
  null
  
)

export default component.exports